<template id="menu-cont">
    <nav id="sidebar">
        <div id="dismiss">
            <img src="/static/imgs/ic_menu.png" alt="menu" class="im_menu1">
        </div>

        <div class="sidebar-header" style="font-size: 1.1em">
            <br>
            <br>
            <img src="/static/imgs/advice_b_horizontal.png" alt="menu" style="width: 60%">
            <br>
            <br>
            <span v-if="user.idioma==0" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; font-weight: bold;">Português</span>
            <span v-if="user.idioma!=0" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; " @click="changeIdioma(0)">Português</span>
            <span v-if="user.idioma==1" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; font-weight: bold;">English</span>
            <span v-if="user.idioma!=1" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; margin-right:10px; " @click="changeIdioma(1)">English</span>
            <span v-if="user.idioma==2" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt; font-weight: bold;">Español</span>
            <span v-if="user.idioma!=2" onMouseOver="this.style.cursor='pointer'" style="font-size: 10pt;" @click="changeIdioma(2)">Español</span>
            <br>
            <br>

            <div style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                <div class="div_botao_t_b" @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'">
                    <span class="tx_continuar"> {{ getInterText(inter_ind.entrar) }} </span>
                </div>

                <router-link to="mRegisterUser" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                    <div class="div_botao_t_w">
                        <span class="tx_continuar"> {{ getInterText(inter_ind.cadastre) }} </span>
                    </div>
                </router-link>
            </div>
        </div>
        <ul class="list-unstyled components">
            <li class="active">
                <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu">{{ getInterText(inter_ind.categorias) }}</a>
                <ul class="collapse list-unstyled" id="pageSubmenu" >
                    <li v-for="item in cats_full" @click="atualizaEstabs(item.id, true)">
                        <a href="#"><img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min">{{ item.nome }}</a>
                    </li>
                </ul>
            </li>
            <li>
                <a href="#">{{ getInterText(inter_ind.quem_somos) }}</a>
            </li>
            <li class="active">
                <a href="#pageSubmenu2" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu2">{{ getInterText(inter_ind.telefones_uteis) }}</a>
                <ul class="collapse list-unstyled" id="pageSubmenu2">
                    <li v-for="item in telefoneUteis">
                        <a :href="'tel:' + trimAll(item.tel)" style="margin-left: 5px">{{ getInterText(item.nome) }}: {{ item.tel }}</a>
                    </li>
                </ul>
            </li>
        </ul>
    </nav>

</template>

<script>
    import { advMixin } from '../../scripts/advMixin';
    // import Vue from 'vue';

    // Vue.mixin(advMixin);

    export default {
        mixins: [advMixin],
        name: 'MenuBar',
        data () {
            return {

            }
        },
        methods: {

        },
        created() {
            console.log('created!!');

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                if (this.$route.params.search) {
                    this.search_text = this.$route.params.search;
                    if (this.search_text.length > 0) {
                        this.showingSearch = true;
                    }
                }
                this.atualizaParametros();
            }
            else {
                console.log('Baixando estabs!!');
                this.getEstabsCats();
            }

            console.log('Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');

            console.log('Terminei o mounted!!');
        },

    }



</script>

<style src="../../assets/css/adv.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #dismiss {
        top: 0;
        left: 0;
        margin-left: 5px;
        margin-top: 10px;
    }
    .im_menu1 {
        height: 25px;
        vertical-align: middle;
        margin-left: 5px;
        top: 0;
        bottom: 0;
        margin-top: auto;
        margin-bottom: auto;
    }
    .im_menu1 {
        top: 0;
        left: 0;
        position: relative;
        margin-left: 0px;
    }
    .im_cat_min {
        width: 17px;
        height: 17px;
        margin-right: 10px;
        object-fit: contain;
    }

</style>



// WEBPACK FOOTER //
// src/components/templates/MenuBar.vue